<template>
  <div style="height:100%">
    <div id="contain">
      <div class="fogdiv">
        <el-button type="primary" size="small" @click="flyto">定位地下</el-button>
      </div>

    </div>
    <!--<div id="loadingOverlay"><h1>Loading........</h1></div>-->
  </div>
</template>
<script>
  import util from '../../components/util'
  import { constants } from 'crypto';
  export default {
    data () {
      return {
        viewer:null,
        activeShapePoints : [],
        activeShape:null,
        floatingPoint:null,
        points:[],
        polyes:[],
        shape:null,
        pol:[]
      }
    },
    mounted(){
      var loa=document.getElementById('loadingOverlay');

      this.init()
    },
    methods:{
      init(){
        this.viewer=util.getViewer('contain',{
          // imageryProvider: new Cesium.UrlTemplateImageryProvider({
          //   url: 'http://www.google.cn/maps/vt?lyrs=s@716&x={x}&y={y}&z={z}'
          // }),
          terrainProvider: Cesium.createWorldTerrain()
        });
        this.viewer.scene.globe.depthTestAgainstTerrain = true;

        let viewer = this.viewer;




        var scene = viewer.scene;
        var globe = scene.globe;
        scene.screenSpaceCameraController.enableCollisionDetection = false;
        globe.translucency.frontFaceAlphaByDistance = new Cesium.NearFarScalar(
                400.0,
                0.0,
                800.0,
                1.0
        );

        var longitude = -3.82518;
        var latitude = 53.11728;
        var height = 299;
        var position = Cesium.Cartesian3.fromDegrees(
                longitude,
                latitude,
                height
        );
        var url = "/demo/static/3d_map/data/ParcLeadMine.glb";
        var url2 = "/demo/static/data/models/car.glb";
        var url22 = "/demo/static/data/models/Gstation.gltf";

        var entity = viewer.entities.add({
          position: position,
          model: {
            uri: url22,
            scale: 1
          },
        });
        // console.log(entity)
        globe.translucency.enabled = true;
        globe.translucency.frontFaceAlphaByDistance.nearValue = 0.5;
        globe.translucency.frontFaceAlphaByDistance.farValue = 1;

        viewer.zoomTo(entity);

        // viewer.scene.camera.flyTo({
        //   destination: new Cesium.Cartesian3(
        //           3827270.552916987,
        //           -255123.18143177085,
        //           5079147.091351856
        //   ),
        //   orientation: new Cesium.HeadingPitchRoll(
        //           3.2624281242239963,
        //           -0.22213535190506972,
        //           6.282786783842843
        //   ),
        //   duration: 1.0,
        // });

        let camera = viewer.scene.camera;
        camera.percentageChanged = 0.1;
        let cameraArray = [];
        camera.changed.addEventListener(function() {
          cameraArray = []
          var p = Cesium.Cartographic.fromCartesian(camera.position);
          let cameraLongitude = Cesium.Math.toDegrees(p.longitude)
          let cameraLatitude = Cesium.Math.toDegrees(p.latitude)
          let cameraHeight = p.height
          // cameraArray.push(parseFloat(cameraLongitude.toFixed(6)))
          // cameraArray.push(parseFloat(cameraLatitude.toFixed(6)))
          // cameraArray.push(parseFloat(cameraHeight.toFixed(2)))
          // cameraArray.push(parseFloat(Cesium.Math.toDegrees(camera.heading).toFixed(2)))
          // cameraArray.push(parseFloat(Cesium.Math.toDegrees(camera.pitch).toFixed(2)))
          // cameraArray.push(parseFloat(Cesium.Math.toDegrees(camera.roll).toFixed(2)))

          cameraArray.push(parseFloat(cameraLongitude))
          cameraArray.push(parseFloat(cameraLatitude))
          cameraArray.push(parseFloat(cameraHeight))
          cameraArray.push(parseFloat(Cesium.Math.toDegrees(camera.heading)))
          cameraArray.push(parseFloat(Cesium.Math.toDegrees(camera.pitch)))
          cameraArray.push(parseFloat(Cesium.Math.toDegrees(camera.roll)))
          // console.log(cameraArray)
        });




      },
      flyto(){
        let params =[-3.824841221507065, 53.11692285922363, 303.4186225903094, 339.0753872486359, 2.266549094640691, 359.93391207255587]
        let cameraParams  = {
          destination: Cesium.Cartesian3.fromDegrees(params[0], params[1], params[2]),
          orientation: {
            heading: Cesium.Math.toRadians(params[3]),
            pitch: Cesium.Math.toRadians(params[4]),
            roll: Cesium.Math.toRadians(params[5])
          }
        }
        let ab= this.viewer;
        this.viewer.scene.camera.animation = true;
        this.viewer.scene.camera.flyTo(cameraParams);

      }
    }
  }
</script>
<style scoped>
  #contain{
    height:100%
  }
  .fogdiv {
    position: absolute;
    margin-left: 25px;
    margin-top: 7px;
    z-index: 999;
    background-color: rgba(0, 0, 0, 0.5);
  }
</style>
